import type { TColor, TColorKey } from '@Theme';
import styled from 'styled-components/native';

import OwnableTheme from '../../../assets/OwnableTheme';

export const StyledSection = styled.View``;

export const StyledSectionHeader = styled.Text<{
  color?: TColorKey;
  fontSize?: keyof typeof OwnableTheme.fontSizes;
  padding?: string;
}>`
  color: ${(props) =>
    props.color
      ? OwnableTheme.colors[props.color]
      : OwnableTheme.colors.persianIndigo};
  font-size: ${({ fontSize }) =>
    fontSize ? OwnableTheme.fontSizes[fontSize] : OwnableTheme.fontSizes.ml};
  font-weight: 700;
  font-family: ${OwnableTheme.fonts.gilroy.bold};
  letter-spacing: 0.03em;
  line-height: 27px;
  padding: ${({ padding }) => padding ?? '0 0 30px 0'};
  align-self: flex-start;
`;

export const StyledFieldContainer = styled.View<{
  width?: number | string;
  maxWidth?: number | string;
  align?: 'center' | 'left' | 'right';
}>`
  flex-direction: column;
  max-width: ${({ maxWidth = '100%' }) => maxWidth};
  width: ${({ width = '100%' }) => width};
  align-items: ${({ align = 'left' }) => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default: // do nothing
    }
  }};
`;

export const StyledInputLabel = styled.Text<{
  align?: 'center' | 'left' | 'right';
  marginLeft?: number;
  marginRight?: number;
  color?: TColor;
}>`
  color: ${({ color }) => color ?? OwnableTheme.colors.persianIndigo};
  font-size: ${() => OwnableTheme.fontSizes.xs};
  font-weight: bold;
  margin-right: ${({ marginRight }) => marginRight ?? `10px`};
  margin-left: ${({ marginLeft }) => marginLeft ?? `0px`};
  padding-bottom: 5px;
  padding-top: 5px;
  align-self: ${({ align = 'left' }) => {
    switch (align) {
      case 'left':
        return 'flex-start';
      case 'center':
        return 'center';
      case 'right':
        return 'flex-end';
      default: // do nothing
    }
  }};
`;

export const StyledBlurb = styled.Text`
  color: ${() => OwnableTheme.colors.black};
  font-size: ${() => OwnableTheme.fontSizes.xs};
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  line-height: 20px;
  letter-spacing: 0.03em;
  font-weight: 600;
  margin-right: 10px;
  padding-bottom: 5px;
  padding-top: 5px;
`;

export const StyledAlignBottom = styled.View<{
  margin?: string;
}>`
  flex-direction: row;
  width: 50%;
  margin: ${({ margin }) => margin ?? '0'};
`;

export const ActionButtons = styled.View<{ margin: string }>`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-around;
  margin: ${({ margin }) => margin ?? '0'};
`;

export const StyledDefaultTag = styled.Text<{ color: TColor; bgColor: TColor }>`
  padding: 5px;
  color: ${({ color }) => color ?? OwnableTheme.colors.white};
  background-color: ${({ bgColor }) =>
    bgColor ?? OwnableTheme.colors.persianIndigo};
  font-size: ${() => OwnableTheme.fontSizes.xs};
  font-weight: normal;
  border-radius: 5px;
  width: 120px;
  margin: 0 5px 0 0;
`;

// todo: seems dodgy that it isn't a modal component
export const StyledModalOverlay = styled.View`
  position: absolute;
  z-index: 1000;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;
